/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-08.
 * General helpers
 */
import { isEmpty, indexOf } from 'lodash';
import { v1 } from 'node-uuid';

export const clampNumber = (number, min, max) => {
    return Math.max(min, Math.min(number, max));
};

export const parsePath = (path = '') => {
    return !path ? [] : path.split('>')
        .map(e => (e[0] === '$' ? parseInt(e.slice(1), 10) : e));
};

export const serializeParams = (params) => {
    const reduce = (a, k) => {
        a.push(`${k}=${encodeURIComponent(params[k].toString())}`);
        return a;
    };
    const queryString = isEmpty(params) ? ''
        : `?${Object.keys(params).reduce(reduce, []).join('&')}`;
    return queryString;
};

export const extractProperty = (data, prop = 'id') => {
    return data.map(x => x[prop]);
};

export const findSelectedIndex = (data, value, prop = 'id') => {
    return indexOf(extractProperty(data, prop), value);
};

export const errorsEmpty = (errors) => {
    let propsWithErrors = 0;

    Object.keys(errors).forEach(key => {
        if (errors[key].length > 0) {
            propsWithErrors += 1;
        }
    });

    return propsWithErrors === 0;
};

export const getValueFromSelectList = (items, value) => {
    const findedValue = items.find(item => item.id.toString() === value.toString()) || { id: '', name: '' };
    return findedValue;
};

export const buildEmptyObjectFromModel = (objectModel) => {
    let newEmptyObject = {};

    Object.keys(objectModel).forEach(key => {
        newEmptyObject = { ...newEmptyObject, [key]: '' };
    });

    return { ...newEmptyObject, id: v1() };
};



// WEBPACK FOOTER //
// ./common/helpers/general.js